import { Component, Input, OnInit } from '@angular/core';
import { RnSupervisorService } from '../../services/rn-supervisor.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-rn-notice',
    templateUrl: './rn-notice.component.html',
    styleUrls: ['./rn-notice.component.scss'],
    standalone: false
})
export class RnNoticeComponent implements OnInit {

  @Input() wantAppear;

  rnSupervisorNoticeEnabled$: Observable<boolean>;

  constructor(private _rnSupervisorService: RnSupervisorService,) {
  }

  ngOnInit(): void {
    this.rnSupervisorNoticeEnabled$ = this._rnSupervisorService.shouldEnable();
  }

}
